<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="imports.data"
      style="width: 100%"
      row-key="id"
      :lazy="true"
      :span-method="pollingItem"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="imports"
            :options="['settings']"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-count="pageCount"
        :page-size="imports && imports.per_page"
        layout="total, prev, pager, next"
        :total="imports && imports.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import TableSettings from '../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
      loadedIds: [],
      intervals: [],
      pollDelay: 15000,
    };
  },
  computed: {
    imports() {
      return this.$store.getters['imports/paginatedImports'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['imports/tableConfig']));
    },
    loading() {
      return this.$store.getters['imports/loading'];
    },
    pageCount() {
      return this.$store.getters['imports/pageCount'];
    }
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
    imports(newVal, oldVal) {
      if (newVal == oldVal || typeof this.imports.data == 'undefined') {
        return
      }
      const ids = []

      this.imports.data.forEach(element => {
        ids.push(element.id)
      })
      this.intervals.forEach((element, index) => {
        if(ids.indexOf(index) == -1) {
          clearInterval(this.intervals[index])
        }
      })
    }
  },
  async mounted() {
    await this.$store.dispatch('imports/fetchAllWithPagination');
  },

  methods: {
    handleCurrentChange(val) {
      this.$store.commit('imports/setCurrentPage', val);
      this.$store.dispatch('imports/fetchAllWithPagination');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('imports/setSorting', { prop, order});
        this.$store.dispatch('imports/fetchAllWithPagination');
      }
    },
     pollingItem({ row, column, rowIndex, columnIndex }) {
      if (this.loadedIds.indexOf(row.id) === -1 && this.intervals.indexOf(row.id) != -1) {
        clearInterval(this.intervals[row.id])
        return
      }
      if(columnIndex !== 2 || this.loadedIds.indexOf(row.id) != -1 || this.intervals.indexOf(row.id) != -1 || row.status != 'pending') {
        return
      }

      this.loadedIds.push(row.id)
      let self = this
      this.intervals[row.id] = setInterval(async () => {
        if (row.status === 'pending' && self.loadedIds.indexOf(row.id) != -1) {
          let response = await self.$store.dispatch('imports/fetch', row.id);
          row.status = response.status
          row.error = response.error
        } else {
          clearInterval(self.intervals[row.id]);
        }
      }, self.pollDelay)
    }
  }
};
</script>
